.region {
  position: fixed;
  right: var(--space-4);
  bottom: var(--space-4);
  left: var(--space-4);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  align-items: center;
  pointer-events: none;
}

@media (min-width: 640px) {
  .region {
    right: var(--space-5);
    bottom: var(--space-5);
    left: auto;
    align-items: flex-end;
  }
}

.toast {
  max-width: var(--width-prose);
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface-overlay);
  box-shadow: var(--shadow-lg);
  font-size: var(--text-sm);
  color: var(--text-primary);
}

.info {
  border-left: 2px solid var(--intent-info);
}

.positive {
  border-left: 2px solid var(--intent-positive);
}

.danger {
  border-left: 2px solid var(--intent-danger);
}
